import { useContext, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ContribuinteContext } from 'contexts/ContribuinteContext';
import { GridContext } from 'contexts/GridContext';
import { useModal } from 'components/Modals';
import DeleteModal from 'components/Modals/DeleteModal';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import DataView, { useDataViewFilters } from 'components/DataView';
import getContribuinteFilterFields from './filterFields';

const Contribuinte = () => {
  const rotina = 'Contribuinte';
  const titulo = 'Contribuintes';
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { openModal, closeModal } = useModal();
  const { deleteGrid, exportPdf, exportXls } = useContext(GridContext);
  const { contribuinte, getContribuinte, getLoading } = useContext(ContribuinteContext);

  const filterFields = useMemo(() => getContribuinteFilterFields(), []);

  const { applyFilter, filterForm } = useDataViewFilters({
    fields: filterFields,
    searchParams,
    setSearchParams,
    onApply: (props) => loadGrid(props),
  });
  const { getValues } = filterForm;

  const loadGrid = (props = {}) => {
    const filter = props?.filter || getValues();

    closeModal();

    getContribuinte({ ...props, rotina, filter });
  };

  const toolbarActions = [
    {
      name: 'Adicionar',
      icon: 'add',
      placement: 'primary',
      action: () => navigate('/app/Tabelas/Contribuinte/Manutencao'),
    },
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({ rotina, filter: getValues(), order: contribuinte?.order }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({ rotina, filter: getValues(), order: contribuinte?.order }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={contribuinte?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
  ];

  const rowActions = [
    {
      name: 'Editar',
      icon: 'edit',
      action: ({ row: values }) =>
        navigate('/app/Tabelas/Contribuinte/Manutencao', {
          state: { values },
        }),
    },
    {
      name: 'Deletar',
      icon: 'delete',
      action: ({ row }) =>
        openModal(
          <DeleteModal
            onSubmit={() =>
              deleteGrid({
                params: { rotina, id: row?.id },
                cb: () => {
                  loadGrid();
                },
              })
            }
          />
        ),
    },
  ];

  return (
    <Container fillHeight>
      <Header
        rotina={rotina}
        titulo={titulo}
        colunas={contribuinte?.colunas}
      />
      <Card fillHeight>
        <DataView
          fillHeight
          grid={contribuinte}
          filterFields={filterFields}
          filterForm={filterForm}
          onFilter={applyFilter}
          toolbarActions={toolbarActions}
          rowActions={rowActions}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
        />
      </Card>
    </Container>
  );
};

export default Contribuinte;

